module.exports = __webpack_public_path__ + "img/id-verifing.92a1b7ff.jpg";